import React from 'react'
import { MessagesSquare, Quote } from 'lucide-react'
import { resolveCommitteeMember } from '../config/ondsConfig'
import { toneColor } from '../utils/tone'

const STANCE_TONE = { bull: 'bull', bear: 'bear', caution: 'caution' }

export default function DebatePanel({ debate = [] }) {
  if (!debate.length) return null

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <MessagesSquare className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">The Debate</h2>
        <span className="text-sm text-[var(--onds-text-dim)]">unfiltered from the committee room</span>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {debate.map((d, i) => {
          const member = resolveCommitteeMember(d)
          const tone = toneColor(STANCE_TONE[d.stance] ?? 'neutral')
          return (
            <div key={i} className="rounded-xl p-4 flex gap-3" style={{ backgroundColor: 'var(--onds-surface)', borderLeft: `3px solid ${member.accent}` }}>
              <div className="w-9 h-9 rounded-lg flex items-center justify-center text-xs font-bold shrink-0" style={{ backgroundColor: `${member.accent}22`, color: member.accent }}>
                {member.initials}
              </div>
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-sm">{member.name}</span>
                  <span className="text-[10px] uppercase tracking-wider font-semibold" style={{ color: tone }}>{d.stance}</span>
                </div>
                <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed relative">
                  <Quote className="h-3 w-3 inline-block mr-1 -mt-1" style={{ color: member.accent }} />
                  {d.quote}
                </p>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
